import React, { useState } from 'react';
import {
  Box,
  Input,
  InputLabel,
  FormControl,
  FormHelperText,
  makeStyles,
  OutlinedInput,
  Typography,
  Grid,
} from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    width: '100%',
    // display: 'flex',
    // justifyContent: 'space-between',
    // columnGap: '1rem',
  },
  formControl: {
    width: '100%',
  },
});

export interface ShippingInformationProps {
  onChange: (name: 'name' | 'email', value: string) => any;
  name?: string;
  email?: string;
  nameError?: string;
  emailError?: string;
}

const ShippingInformation = ({
  onChange,
  name,
  email,
  nameError,
  emailError,
}: ShippingInformationProps) => {
  const classes = useStyles();
  const onChangeHandler = (name, value) => {
    if (onChange) onChange(name, value);
  };
  return (
    <Grid container className={classes.root} spacing={2}>
      <Grid item sm={6} >
        <FormControl className={classes.formControl} variant="standard">
          <InputLabel htmlFor="component-helper" error={!!nameError}>
            {'Name*'}
          </InputLabel>
          <Input
            id="name-input"
            aria-describedby="component-helper-text"
            onChange={(event) => onChangeHandler('name', event.target.value)}
            autoComplete="off"
            value={name}
          />
          {nameError && (
            <FormHelperText id="component-helper-text" error>
              {nameError}
            </FormHelperText>
          )}
        </FormControl>
      </Grid>
      <Grid item sm={6}>
        <FormControl className={classes.formControl} variant="standard">
          <InputLabel htmlFor="component-helper" error={!!emailError}>
            {'Email*'}
          </InputLabel>
          <Input
            id="email-input"
            aria-describedby="component-helper-text"
            onChange={(event) => onChangeHandler('email', event.target.value)}
            autoComplete="off"
            value={email}
          />
          <FormHelperText id="component-helper-text" error={!!emailError}>
            {emailError
              ? emailError
              : 'Download link will be sent to this email'}
          </FormHelperText>
        </FormControl>
      </Grid>
      <Grid item sm={12}>
        <Typography variant="caption">* required fields</Typography>
      </Grid>
    </Grid>
  );
};

export default ShippingInformation;
export { ShippingInformation };
